// extracted by mini-css-extract-plugin
export default {"stage":"Stage_stage__M0xfl","track":"Stage_track__w0jkZ","video":"Stage_video__BXNJK","audio":"Stage_audio__hFQFn","audio-overlay":"Stage_audio-overlay__o0W7C"};